<template>
  <v-container>
    <v-layout row wrap>

        <v-flex sm6>
            <v-card light flat>
              <v-responsive>
                <div class="ml-1">
                  <amaze-squiggle fillColor="fill--primary"></amaze-squiggle>
                </div>
              </v-responsive>
              <v-card-title>
                <h1 class="uppercase">Professional<br> Development</h1>
              </v-card-title>
              <v-card-text>
                <h2>Tool kits and interactive resources are delivered to educators and school leaders in an easy-to-use platform.</h2>
                <div>
                  <v-btn color="primary text--grey text--darken-4" light>Primary</v-btn>
                </div>
              </v-card-text>
            </v-card>
        </v-flex>
        <v-flex sm6>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sequi voluptatum qui, dolorum. Quaerat eius,
          non asperiores porro natus hic aliquid, incidunt consequatur explicabo, nihil similique ab sed animi,
          doloremque at!</p><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Delectus dolores commodi sit
          rem fugiat rerum, quibusdam voluptas voluptatum totam, porro autem, explicabo deserunt ducimus ea dolorem alias! Nam,
          perspiciatis, repellendus.</p>
        </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
}
</script>
